import React from "react";
import AddButtonComponent from "../../../../components/AddButtonComponent/AddButtonComponent";
import UserActionComponent from "../UserActionComponent/UserActionComponent";
import "./StageComponent.scss";
import PropTypes from "prop-types";
import { Draggable, Droppable } from "react-beautiful-dnd";
import TitleBanner from "../../../../components/TitleBanner/TitleBanner";
import { useSelector } from "react-redux";
import { fetchStageById } from "../../../../store/coreSlice";

function StageComponent({
  goalId,
  stageId,
  index,
  handleAddUserActionClick,
  handleAddStage,
}) {
  const stage = useSelector(fetchStageById(stageId));

  return (
    <>
      {stage && (
        <Draggable
          key={`draggable-${goalId}-${stage.id}`}
          draggableId={`${goalId}+${stage.id}`}
          index={index}
        >
          {(goalDraggableProvided, goalDraggableSnapshot) => (
            <article
              className="stage-wrapper draggable-entity"
              key={`${goalId}-${stage.id}`}
              ref={goalDraggableProvided.innerRef}
              {...goalDraggableProvided.draggableProps}
              {...goalDraggableProvided.dragHandleProps}
            >
              <TitleBanner
                placeholder="Title of Stage"
                enableAutoFocus={index > 0}
                handleOnEnterPress={handleAddStage.bind(this, index)}
              />

              <section className="image-dropper text-center">
                <div>
                  <p>Drag & Drop image here</p>
                  <p>or</p>
                  <button type="file" accept="image/png, image/jpeg, image/jpg">
                    Browse Image Library
                  </button>
                </div>
              </section>

              <section className="description">
                <textarea
                  name="description"
                  id="description"
                  rows="6"
                  placeholder="Description..."
                ></textarea>
              </section>

              <hr className="stage-separator" />

              <Droppable
                droppableId={`${stage.id}`}
                direction="horizontal"
                type="User_Action"
              >
                {(droppableProvided, droppableSnapshot) => (
                  <section
                    className="user-action-list"
                    ref={droppableProvided.innerRef}
                    {...droppableProvided.droppableProps}
                  >
                    {stage.userActions.map((action, index) => (
                      <Draggable
                        key={`draggable-${action.parentId}-${action.actionId}`}
                        draggableId={`${action.parentId}+${action.actionId}`}
                        index={index}
                      >
                        {(draggableProvided, draggableSnapshot) => (
                          <div
                            key={`${action.parentId}-${action.actionId}`}
                            ref={draggableProvided.innerRef}
                            className={
                              "user-action-item " +
                              (draggableSnapshot.isDragging ? "dragged" : "")
                            }
                            {...draggableProvided.draggableProps}
                            {...draggableProvided.dragHandleProps}
                          >
                            <UserActionComponent
                              enableAutoFocus={index > 0}
                              text={action.text}
                              placeholder="User action..."
                              handleOnEnterPress={handleAddUserActionClick.bind(
                                this,
                                stage.id,
                                index
                              )}
                            />
                            {/* <UserActionComponent
                              text={action.text}
                              placeholder="User action..."
                            /> */}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {droppableProvided.placeholder}
                    <section className="add-action-wrapper">
                      <AddButtonComponent
                        title="Add Stage Card"
                        handleAddButtonClick={handleAddUserActionClick.bind(
                          this,
                          stage.id,
                          -1
                        )}
                      />
                    </section>
                  </section>
                )}
              </Droppable>
            </article>
          )}
        </Draggable>
      )}
    </>
  );
}

StageComponent.propTypes = {
  goalId: PropTypes.string.isRequired,
  stageId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  handleAddUserActionClick: PropTypes.func.isRequired,
  handleAddStage: PropTypes.func.isRequired,
};

export default StageComponent;
